import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { WebsiteHostnameContainerModel } from '../../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class WebsiteHostnameService extends BaseApiPublicLoginTemplateService<WebsiteHostnameContainerModel, WebsiteHostnameContainerModel, WebsiteHostnameContainerModel> {
  static readonly WEBSITE_HOSTNAME_SUB_PATH = 'website-hostnames/';

  constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteHostnameService.WEBSITE_HOSTNAME_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteHostnameService.WEBSITE_HOSTNAME_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
      this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteHostnameService.WEBSITE_HOSTNAME_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
      this.httpClient = http;
  }
}
